import type { ReactNode, RefObject } from "react";
import type { MemeGeneratorState } from "store/features/memeGenerator/types";

interface PreviewContentContainerProps {
    children: ReactNode;
    itemsContainerSettings: NonNullable<MemeGeneratorState["meme"]>["settings"]["itemsContainer"];
    itemsContainerRef?: RefObject<HTMLDivElement>;
}

export const PreviewContentContainer = ({
    children,
    itemsContainerSettings,
    itemsContainerRef,
}: PreviewContentContainerProps) => {
    return (
        <div
            style={{
                width: itemsContainerSettings.width,
                height: itemsContainerSettings.height,
            }}
        >
            <div
                className="absolute overflow-hidden"
                style={{
                    left: itemsContainerSettings.left,
                    top: itemsContainerSettings.top,
                    width: itemsContainerSettings.width,
                    height: itemsContainerSettings.height,
                }}
                ref={itemsContainerRef}
            >
                <div className="relative w-full h-full">{children}</div>
            </div>
        </div>
    );
};
